export default {"src":"/_next/static/media/community.b621dfad.svg","height":32,"width":32};